/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signature Maker — Draw or Type & Download PNG | Toolverse`)
};

const es_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Firmas — Dibuja, Escribe y Descarga PNG | Toolverse`)
};

const de_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaturmaker — Zeichnen oder eingeben & PNG herunterladen | Toolverse`)
};

const nl_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handtekeningmaker — Teken of typ & download PNG | Toolverse`)
};

const fr_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de Signature — Dessinez ou Tapez et Téléchargez PNG | Toolverse`)
};

const it_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di firme — Disegna o Digita e Scarica PNG | Toolverse`)
};

const pt_br2_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Assinatura — Desenhe ou Digite e Baixe PNG | Toolverse`)
};

const pt_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Assinaturas — Desenhe ou Escreva & Descarregue PNG | Toolverse`)
};

const ja_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名メーカー — 描くまたは入力してPNGダウンロード | Toolverse`)
};

const zh_sig_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`签名制作工具 — 绘制或输入并下载 PNG | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_meta_title", locale)
	if (locale === "en") return en_sig_hub_meta_title(inputs)
	if (locale === "es") return es_sig_hub_meta_title(inputs)
	if (locale === "de") return de_sig_hub_meta_title(inputs)
	if (locale === "nl") return nl_sig_hub_meta_title(inputs)
	if (locale === "fr") return fr_sig_hub_meta_title(inputs)
	if (locale === "it") return it_sig_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_meta_title(inputs)
	if (locale === "pt") return pt_sig_hub_meta_title(inputs)
	if (locale === "ja") return ja_sig_hub_meta_title(inputs)
	return zh_sig_hub_meta_title(inputs)
};